/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from 'react';
import "@9softstudio/react-monthpicker/dist/reactmonthpicker.css";
import 'moment/locale/es';
import { closelightbox } from "../../../util/Functions";
import { format } from "../../../util/DateUtil";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import * as FORMAT from 'react-day-picker/moment';
import moment from 'moment';
import * as API from '../../../http/api';
import { REGEX_EMAIL } from "../../../util/RegEx";

const ContraCargoInternacional = (props) => {

    const [data, setData] = useState({});
    const [sectionOptions,setSectionOptions] = useState([
        {"id":"0","input":true,"text":"Goods or services were not as described or defective, includes shipped merchandise received damaged or not suitable for its intended purpose or merchant didn’t honor the terms and conditions of a contract.Delivery date of the goods or services"},
        {"id":"1","input":true,"text":"Goods or services were not provided. Expected delivery date of the goods or services:"},
        {"id":"2","input":false,"text":"Digital goods were purchased totaling USD 25.00 or less and did not have adequate purchase controls"},
        {"id":"3","input":true,"text":"Credit not processed. Return or cancellation date:"},
        {"id":"4","input":false,"text":"Counterfeit goods alleged to be authentic were purchased"},
        {"id":"5","input":true,"text":"Recurring transaction cancelled prior to billing Cancellation date:"},
        {"id":"6","input":false,"text":"Recurring agreement was not properly disclosed"},
        {"id":"7","input":false,"text":"Addendum dispute"},
        {"id":"8","input":false,"text":"“No-Show” hotel charge was billed"},
        {"id":"9","input":false,"text":"Purchase transaction did not complete"},
        {"id":"10","input":false,"text":"Timeshare agreement or similar service provision was cancelled within Mastercard time frame"},
        {"id":"11","input":false,"text":"Credit posted as a purchase"},
    ]);
    const [sectionBOptions,setSectionBOptions] = useState([
        {"id":"0","input":true,"text":"The cardholder was debited more than once for the same goods or services. Alternate means of payment details:"},
        {"id":"1","input":false,"text":"The cardholder was debited an incorrect amount."},
        {"id":"2","input":false,"text":"Counterfeit goods alleged to be authentic were purchased"},
        {"id":"3","input":false,"text":"Recurring agreement was not properly disclosed"},
        {"id":"4","input":false,"text":"Addendum dispute"},
    ]);
    const [sectionA,setSectionA] = useState(true);
    const [sectionB,setSectionB] = useState(true);
    const [sectionViewA,setSectionViewA] = useState(true);
    const [sectionViewB,setSectionViewB] = useState(true);
    const [textSectionA,setTextSectionA] = useState("");
    const [textSectionB,setTextSectionB] = useState("");
    const [inputSectionA,setInputSectionA] = useState(false);
    const [inputSectionB,setInputSectionB] = useState(false);
    const [date,setDate] = useState("");
    const [dateDesc,setDateDesc] = useState("");
    const [reason,setReason] = useState("");
    const [auxIndex,setIndex] = useState(null);
    const [msnReasonError,setReasonMsnError] = useState("");
    const [msnError,setMsnError] = useState("");
    const [msnDesc,setDesc] = useState("");
    const [disabled,setDisabled] = useState(true);
    const [disabledEnvio,setDisabledEnvio] = useState(true);
    const [startDate, setStartDate] = useState(new Date());
    const [name,setName] = useState("");
    const [phone,setPhone] = useState("");
    const [populationId,setPopulationID] = useState("");
    const [email,setEmail] = useState("");
    var   [emailSend,setEmailSend] = useState("");
    const [emailDisable,setEmailDisable] = useState(false)
    const [sendEmail, setSendEmail] = useState(false);
    const [checkA,setCheckA] = useState([
        {
            "check": false,
            "value": ""
        },
        {
            "check": false,
            "value": ""
        },
        {
            "check": false,
        },
        {
            "check": false,
            "value": ""
        },
        {
            "check": false
        },
        {
            "check": false,
            "value": ""
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        }
    ])

    const [checkB,setCheckB] = useState([
        {
            "check": false,
            "value": ""
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        }
    ])
 
    useEffect(() => {
        setData(props.data);
        var date = new Date();
        setDateDesc(date.toJSON().substring(0, 10))
        if (props.config["actions"].indexOf("sendEmail") > -1) {
            setSendEmail(true);
        }
        init();
    }, [])

    const init  = async ()=>{
        setName(props.customer.name);
        setEmail(props.customer.email);
        setPopulationID(props.customer.populationid);
        setPhone(props.customer.phone);
    }
 
    const handleSectionOption = (event)=>{
        let value = event.target.value;
        let aux;
        sectionOptions.map((data, index)=>{
            if(data.text === value){
                resetChecks();
                aux = data;
                setInputSectionA(aux.input)
                setSectionA(false)
                setSectionViewB(false)
                setTextSectionA(value)
                setIndex(index)
                checkA[index].check = true;
                if(!checkA[index].hasOwnProperty('value')){
                    setDisabled(false)
                    setDisabledEnvio(false)
                }
            }
        })
    }

    const handleSectionBOption = (event)=>{
        let value = event.target.value;
        let aux;
        sectionBOptions.map((data,index)=>{
            if(data.text === value){
                resetChecks();
                aux = data;
                setInputSectionB(aux.input)
                setSectionB(false)
                setSectionViewA(false)
                setTextSectionB(value)
                setIndex(index)
                checkB[index].check = true;
                if(!checkB[index].hasOwnProperty('value')){
                    setDisabled(false)
                    setDisabledEnvio(false)
                }
            }
        })
    }

    const resetSection = () =>{
        setSectionA(true);
        setSectionB(true);
        setSectionViewA(true)
        setSectionViewB(true)
        setInputSectionA(false)
        setInputSectionB(false)
        setIndex(null)
        setDate("")
        setMsnError("")
        setReasonMsnError("")
        setReason("")
        setDisabled(true)
        setDisabledEnvio(true)
    }

    const valid = ()=>{

        if(sectionViewA && sectionViewB){
            setMsnError("Seleccione una opción de la seccion A o B")
            props.changeLoader(false);
            return false;
        }else if(sectionViewA){
            if(inputSectionA  && date.length === 0){
                setMsnError("Determine la fecha")
                props.changeLoader(false);
                return false;
            }else if(inputSectionA){
                checkA[auxIndex].value = date;
                return true;
            }
        }else if(sectionViewB){
            if(inputSectionB && reason ===""){
                setReasonMsnError("The alternate means payment is required")
                props.changeLoader(false);
                return false;
            }else if(inputSectionB){
                checkB[auxIndex].value = reason;
                return true;
            }
        }
    }

    const descarga = async ()=>{
        props.changeLoader(true);
        if(!valid){
            return;
        }
        setMsnError("")
        setReasonMsnError("")
        var data = {
            "type": "resolucion-ttk",
            "content": {
                "reference": props.data.reference,
                "transactInformation": {
                    "serialNumber": props.data.tracking_key,
                    "merchantName": props.data.concept,
                    "transactDate": formatDate(props.data.cdate),
                    "transactAmount": props.data.amount.toString(),
                    "disputedAmount": props.data.amount.toString(),
                    "cardholderName":name,
                    "identityNumber": populationId,
                    "contactNumber": phone,
                    "email":email,
                    "wallet": props.data.walletID,
                    "cardNumber": "",
                },
                "secA": {
                    "checks": checkA,
                    "participation": sectionViewA
                },
                "secB": {
                    "checks":checkB
                },
                "secC": {
                    "description": msnDesc,
                    "date": formatDate(dateDesc)    
                }
            },
            "url": "signed",
            "agent_uuid": JSON.parse(localStorage.session).uuid
        }


        let request = await API.service('cartasDocs', data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if(request.status === 200){
            if(request.data.data.response === "OK"){
                var dataResult = request.data.data.widget[0].content.url;
                props.changeAlert(true, 'success', 'Carta de contra cargos creada con éxito');
                window.open(dataResult, '_blank');
            }else{
                props.changeAlert(true, 'error', 'Error al crear la carta de contra cargos.');
            }
        }

        closelightbox();
        props.changeLoader(false);
    }

    const enviar = async ()=>{
        props.changeLoader(true);
        if(!valid){
            return;
        }
        setMsnError("")
        setReasonMsnError("")
        var data = {
            "type": "resolucion-ttk",
            "content": {
                "reference": props.data.reference,
                "transactInformation": {
                    "serialNumber": props.data.tracking_key,
                    "merchantName": props.data.concept,
                    "transactDate": formatDate(props.data.cdate),
                    "transactAmount": props.data.remote_account?.authorization_number,
                    "disputedAmount": props.data.amount.toString(),
                    "cardholderName":name,
                    "identityNumber": populationId,
                    "contactNumber": phone,
                    "email":email,
                    "wallet": props.data.walletID,
                    "cardNumber":props.data.card.pan_masked,
                },
                "secA": {
                    "checks": checkA,
                    "participation": sectionViewA
                },
                "secB": {
                    "checks":checkB
                },
                "secC": {
                    "description": msnDesc,
                    "date": formatDate(dateDesc)    
                }
            },
            "url": "signed",
            "agent_uuid": JSON.parse(localStorage.session).uuid
        }

        /*
        var requestSend = await API.service('sendGridSendEmail', "", props.pos, props.changeAlert, props.changeLoader, props.history);        
        console.log(requestSend)
        */
        
        let request = await API.service('cartasDocs', data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if(request.status === 200){
            if(request.data.data.response === "OK"){
                var url = request.data.data.widget[0].content.url;

                if(!REGEX_EMAIL.test(emailSend)){   
                    emailSend = email;
                }

                var dataSend ={
                    url:url,
                    email: emailSend,
                    docName: "Contracargo internacional",
                    name:name
                }

                var requestSend = await API.service('cartasDocsSend', dataSend, props.pos, props.changeAlert, props.changeLoader, props.history);        
                
                if(requestSend.status == 200 && requestSend.data.data.response === "OK"){
                    props.changeAlert(true, 'success', 'Carta de contra cargos enviada con éxito');
                }else{
                    props.changeAlert(true, 'error', 'Error al enviar la carta de contra cargos.');
                }
                
            }else{
                props.changeAlert(true, 'error', 'Error al enviar la carta de contra cargos.');
            }
        }

        
        closelightbox();
        props.changeLoader(false);
    }

    const resetChecks = ()=>{
        checkA.map(data=>{
            data.check = false;
        })

        checkB.map(data=>{
            data.check = false;
        })
    }

    const changeReason = (event)=>{ 
        var value = event.target.value;
        if(value.trim().length > 0){
            setReason(value)
            setDisabled(false)
            setDisabledEnvio(false)
        }else{
            setReason("")
            setDisabled(true)
            setDisabledEnvio(true)
        }
    }
    
    const changeDateDesc = (event)=>{ 
        var value = event.toJSON().substring(0, 10);
        setDateDesc(value)
        setDisabled(false)
        setDisabledEnvio(false)
    }

    const changeDate = (event)=>{ 
        var value = event.toJSON().substring(0, 10);
        setDate(value)
        setDisabled(false)
        setDisabledEnvio(false)
    }

    const formatDate = (date)=>{
        return format(date);
    }

    const editEmail = ()=>{
        if(emailDisable){
            setEmailDisable(false);
            setDisabledEnvio(false)
        }else{
            setEmailDisable(true);
            setDisabledEnvio(true)
        }
    }

    const newEmailSend = (event) =>{
        var value = event.target.value;
        if ( !REGEX_EMAIL.test(value)) {
            setDisabledEnvio(true)
            setEmailSend(email)
            return;
        } else {
            setDisabledEnvio(false)
            setEmailSend(value);
        }   
    }


    return (<div className="card carta-doc">
        <div className="text-right modal_header_close">
            {
              <div
                className="tooltip"
                style={{ marginRight: "10px", cursor: "pointer" }}
              >
                <span className="tooltiptext tooltip-bottom">Descargar</span>
                <i className="ibon-download" onClick={descarga} ></i>
              </div>
            }

            <div className="tooltip">
              <span className="tooltiptext tooltip-bottom">Cerrar</span>
              <i className="ibon-close tap" onClick={closelightbox}></i>
            </div>
        </div>
        <h3 className="modal_header_title">Carta Internacional</h3>
        
        <div className="">
            <div className="carta-header">
                <h2>Cargos Internacionales</h2>
            </div>

            <div className="carta-form">
                <div className="carta-form-personal">
                    <h3>Transaction Information:</h3>
             
                    <br />
                 
                    <div className="card-form-personal-data">
                        <div className="card-form-data-flex">
                            <p>
                                <span>Merchant Name:</span> {props.data.concept}
                            </p>
                            <p><span>Transaction Amount:</span> {props.data.remote_account?.authorization_number}</p>
                        </div>

                        <div className="card-form-data-flex">
                            <p>
                                <span>Transaction or Settlement Date:</span> {formatDate(props.data.cdate)}
                            </p>
                            <p>
                                <span>Disputed Amount:</span> {props.data.amountFormated}
                            </p>
                        </div>
                    </div>
                    <h3>Cardholder details:</h3>

                    <div className="card-form-personal-data">
                        <div className="card-form-data-flex">
                            <p><span>Cardholder full name:</span> {name}</p>
                            <p><span>Contact number:</span> {phone} </p>
                            <p><span>Wallet ID:</span>{props.data.walletID}</p>
                        </div>

                        <div className="card-form-data-flex">
                            <p><span>Identity number:</span> {populationId}</p>
                            <p><span>Email address:</span> {email}</p>
                            <p><span>Card Number:</span> {props.data.card.pan_masked}</p>
                        </div>
                    </div>

                </div>

                <h3>Complete Section A or Section B as applicable and Section C:</h3>

                {sectionViewA &&
                    <div className="carta-form-section">
                        <h3>Section A</h3>
                        <h3>Cardholder Dispute Chargeback</h3>
                        <h3>Type of Cardholder Dispute (check one):</h3>

                        {sectionA &&
                            <ul>
                                {sectionOptions.map(data=>{
                                    return (
                                    <li>
                                        <input style={{marginTop:"4px"}}  type="checkbox" onChange={handleSectionOption.bind(this)} value={data.text} />
                                        <span> 
                                            {data.text} 
                                            {data.input &&
                                                <span>_______________</span>
                                            }
                                        </span>
                                    </li>)
                                })
                                }
                            </ul>
                        }
                        {!sectionA &&
                            <ul>
                                <li><input style={{marginTop:"4px"}} type="checkbox" checked onChange={resetSection}/>  
                                    <span>
                                        {textSectionA}
                                        {inputSectionA &&
                                            <DayPickerInput
                                                style={{height: '30px', width: '25%'}}
                                                onDayChange={changeDate}
                                                placeholder='Select the date'
                                                format="DD-MM-YYYY"
                                                inputProps={{
                                                    readOnly: true
                                                }}
                                                formatDate={FORMAT.default.formatDate}
                                                parseDate={FORMAT.default.parseDate}
                                                dayPickerProps={{
                                                    months: ["Ene", "Feb", "Mar","Abr", "May", "Jun","Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
                                                    pagedNavigation: true,
                                                    numberOfMonths: 1,
                                                }}
                                            />
                                        }
                                    </span>
                                </li>
                       
                            </ul>
                        }

                        <h3>Cardholder Participation:</h3>
                        <p className="row">
                            <span className="col-6">
                                Did the cardholder participate in the transaction?
                            </span>
                            {sectionA &&
                                <span className="row">
                                    <label htmlFor="">Yes <input type="checkbox" /></label>
                                    <label htmlFor="">No <input type="checkbox" /></label>
                                </span>
                            }
                            {!sectionA &&
                                <span className="row">
                                    <label htmlFor="">Yes <input type="checkbox" checked disabled onChange={resetSection} /></label>
                                    <label htmlFor="">No <input type="checkbox"  onChange={resetSection} disabled/></label>
                                </span>
                            }
                           
                        </p>
                    </div>
                }
                {sectionViewB &&
                    <div className="carta-form-section">
                        <h3>Section B</h3>
                        <h3>Point of Interaction (POI)</h3>
                        <h3>Type of Point of Interaction (POI) Error (check one):</h3>
                        {sectionB &&
                            <ul>
                                {sectionBOptions.map(data=>{
                                    return (
                                    <li>
                                        <input style={{marginTop:"4px"}} type="checkbox" onChange={handleSectionBOption.bind(this)} value={data.text} />
                                        <span> 
                                            {data.text} 
                                            {data.input &&
                                                <span>_______________</span>
                                            }
                                        </span>
                                    </li>)
                                })
                                }
                            </ul>
                        }
                        {!sectionB &&
                            <ul>
                                <li><input style={{marginTop:"4px"}} type="checkbox" checked  onChange={resetSection} />  
                                    <span>
                                        {textSectionB}
                                        {inputSectionB &&
                                            <input type="text" style={{width:"50%"}} placeholder="Write the alternate means of payment details." className="ibon-account" onChange={changeReason}/>
                                        }
                                    </span>
                                </li>
                           
                            </ul>
                        }
                        
                        {msnReasonError != "" &&
                            <h6 className="error">{msnReasonError}</h6>
                        }
                    </div>
                }
                <div className="carta-form-section">
                    <h3>Section C</h3>
                    <h3>Dispute Details</h3>

                    <p>Describe the cardholder’s compliant in sufficient detail to meet the requirements for the chargeback as described in the chargeback guide and to enable all parties to understand the dispute</p>
                    <span className="card-reset">Llenar solamente en ingles</span>
                    <textarea   className="carta-textarea"  onChange={(e)=>{setDesc(e.target.value)}}></textarea>

                    <p>
                        Date
                        <DayPickerInput
                            style={{height: '30px', width: '25%',margin:'0 10px'}}
                            onDayChange={changeDateDesc}
                            placeholder='Select the date'
                            format="DD-MM-YYYY"
                            value={startDate}
                            inputProps={{
                                readOnly: true
                            }}
                            formatDate={FORMAT.default.formatDate}
                            parseDate={FORMAT.default.parseDate}
                            dayPickerProps={{
                                months: ["Ene", "Feb", "Mar","Abr", "May", "Jun","Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
                                pagedNavigation: true,
                                numberOfMonths: 1,
                            }}
                        />
                    </p>

                    {sendEmail &&
                        <div className="envioCartaEmail">
                            <p>Ingresar nuevo email <i className="tap ibon-chevron-down" onClick={editEmail}></i>  </p>
                            {emailDisable &&
                                <input type="text"  style={{width:"50%"}} placeholder="Email..." className="ibon-account" onChange={newEmailSend.bind(this)} />
                            }

                            {emailDisable &&
                                <p>Se enviará a {emailSend}, {name} </p>
                            }

                            {!emailDisable &&
                                <p>Se enviará a {email}, {name}</p> 
                            }

                            
                            <div style={{marginRight:"60px"}} className="carta-footer-col-3">
                                {
                                    <div className={ disabled ? 'disable bigButton  pnl-btn-save  pos-left' : 'bigButton pnl-btn-save  pos-left'}>
                                        <button  type="submit" onClick={enviar}>Enviar</button>
                                    </div>
                                }
                            </div>
                            
                            
                        </div>
                    }
                </div>

                {msnError != "" &&
                    <h6 className="error">{msnError}</h6>
                }

                <div className="carta-form-section">
            
                    <div className="carta-footer">
                        <div className="carta-footer-col">
                            <div className="bigButton pos-left">
                                <button onClick={closelightbox} >Cancelar</button>
                            </div>
                        </div>
                        <div className="carta-footer-col-3">
                            <div className={disabled ? 'disable bigButton pos-right pnl-btn-save' : 'bigButton pos-right pnl-btn-save'}>
                                <button disabled={disabled} type="submit" onClick={descarga}>Descargar</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>)
}

export default ContraCargoInternacional;